<template>
  <div id="containerUserMenu">
    <v-menu
      v-model="menu"
      left
      offset-y
      content-class="mt-2"
      attach="#containerUserMenu"
      origin="top center"
    >
      <template #activator="{on, attrs, value}">
        <div style="position: relative">
          <z-btn
            ref="buttonUserMenu"
            class="px-0"
            primary
            small
            color="transparent"
            v-bind="attrs"
            :text="userName"
            v-on="on"
          >
            <template #text>
              <label class="username-label">
                {{ userName }}
              </label>

              <v-avatar
                v-if="srcAvatar || avatarName !== ''"
                size="24"
                class="ml-2"
                color="var(--black-100)"
              >
                <img v-if="srcAvatar" :src="srcAvatar" alt="Profile Avatar" />
                <span v-else>{{ avatarName }}</span>
              </v-avatar>
            </template>
          </z-btn>

          <v-fade-transition>
            <div v-if="value" class="arrow-menu"></div>
          </v-fade-transition>
        </div>
      </template>

      <z-card ref="cardMenu" width="100%" class="px-0">
        <template #content>
          <div style="padding: 0px 10px">
            <div class="body-bold" style="line-height: 18px">
              {{ userName }}
            </div>

            <div
              class="body-text text-truncate"
              style="line-height: 15px; font-size: 13px; max-width: 150px"
            >
              {{ userEmail }}
            </div>
          </div>

          <v-divider style="margin: 10px 0"></v-divider>

          <v-list dense style="padding: 0px">
            <v-list-item
              v-for="(item, index) of items"
              :key="index"
              :disabled="item.disabled"
              @click="$emit('click:item', item)"
            >
              <v-list-item-action class="mr-2">
                <z-icon
                  size="20"
                  color="var(--black)"
                  :style="{opacity: item.disabled ? 0.5 : 1}"
                >
                  {{ item.icon }}
                </z-icon>
              </v-list-item-action>

              <v-list-item-content>
                {{ item.title }}
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="$emit('logout')">
              <v-list-item-action class="mr-2">
                <z-icon size="20" color="var(--black)">$logout</z-icon>
              </v-list-item-action>

              <v-list-item-content class="list-text">
                {{ $t('disconnect') }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
      </z-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'ZUserMenuOptions',
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },

    userName: {
      type: String,
      required: false,
      default: '',
    },

    userEmail: {
      type: String,
      required: false,
      default: '',
    },

    srcAvatar: {
      type: String,
      required: false,
      default: '',
    },
  },

  i18n: {
    messages: {
      en: {
        disconnect: 'Disconnect',
      },
      pt: {
        disconnect: 'Desconectar',
      },
      es: {
        disconnect: 'Desconectar',
      },
      fr: {
        disconnect: 'Déconnecter',
      },
      tr: {
        disconnect: 'Bağlantıyı Kes',
      },
    },
  },

  data() {
    return {
      menu: false,
      activatorWidth: 0,
      cardWidth: 0,
    }
  },

  computed: {
    avatarName() {
      if (!this.userName) return ''

      return this.userName
        .split(' ')
        .map((word) => word.charAt(0))
        .slice(0, 2)
        .join('')
        .toUpperCase()
    },
  },
}
</script>

<style scoped lang="scss">
.username-label {
  font-size: 0.875rem;
  text-transform: capitalize;
  font-weight: 400;
  cursor: pointer;
}

:deep(.v-list-item) {
  min-height: 30px !important;
  height: 30px !important;
  padding: 0 10px;
}

.arrow-menu {
  transform: translateX(-50%);
  position: absolute;
  border-bottom: solid 8px var(--white) !important;
  border-right: solid 8px transparent;
  border-left: solid 8px transparent;
  top: 30px;
  left: 50%;
  height: 0px;
  width: 0px;
  z-index: 9;
}
</style>
